import type { FC } from 'react';
import type { Milestone } from '../types';
import { milestoneStatusLabel } from '../utils/ipcStatusEnums';
import {
  SPEC_TERMINATE_NODE_STATUS_VALUES,
  getSpecTerminateNodeStatusOptions,
  type SpecTerminateNodeChoice,
  type TerminateMatrixCell,
  type TerminateMatrixCol,
} from '../utils/terminateMatrix';
import { TerminateStatusMatrixModal } from './TerminateStatusMatrixModal';

export { SPEC_TERMINATE_NODE_STATUS_VALUES, getSpecTerminateNodeStatusOptions };
export type { SpecTerminateNodeChoice };

/** @deprecated 使用 getSpecTerminateNodeStatusOptions */
export const SPEC_TERMINATE_NODE_STATUS_OPTIONS = SPEC_TERMINATE_NODE_STATUS_VALUES.map(value => ({
  value,
  get label() {
    return milestoneStatusLabel(value);
  },
}));

type Props = {
  open: boolean;
  specTitle: string;
  milestones: Milestone[];
  cols: TerminateMatrixCol[];
  cells: Record<string, TerminateMatrixCell>;
  confirmLoading?: boolean;
  onCancel: () => void;
  onConfirm: (payload: {
    reason: string;
    remark: string;
    nodeStatuses: { ipdSkuId: number; milestoneId: number; status: SpecTerminateNodeChoice }[];
  }) => void | Promise<void>;
};

/** 终止规格弹窗：多 SKU 时按 SKU 分列，列头为 SKU 规格名称 */
export const SpecTerminateModal: FC<Props> = ({
  open,
  specTitle: _specTitle,
  milestones,
  cols,
  cells,
  confirmLoading,
  onCancel,
  onConfirm,
}) => {
  const skuCount = cols.length;
  const title = skuCount > 1 ? `终止规格（${skuCount} 个 SKU）` : '终止规格';
  return (
    <TerminateStatusMatrixModal
      open={open}
      title={title}
      alertTitle="终止为不可恢复的终态。将对以下选中的SKU进行终止；当全部规格均已终止时，项目同步为已终止。"
      selectionMode="spec"
      milestones={milestones}
      cols={cols}
      cells={cells}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      onConfirm={payload =>
        onConfirm({
          reason: payload.reason,
          remark: payload.remark,
          nodeStatuses: payload.nodeStatuses.map(n => ({
            ipdSkuId: n.ipdSkuId,
            milestoneId: n.milestoneId,
            status: n.status,
          })),
        })
      }
    />
  );
};
